export default "/static/dashboard/build/app/img/v2/e03337d987cc3e05639c9db0f22056f5.png";